<style scoped>
.ribbon {
  background: linear-gradient(#f70505 0%, #8f0808 100%);
  height: 38px;
  margin: 0 auto;
  position: absolute;
  width: 50px;
  right: 10px;
  text-align: center;
  vertical-align: middle;
  line-height: 35px;
  font-weight: 700;
  color: #f2f2f2;
  top: 0;
  z-index: 1;
}
.ribbon:after,
.ribbon:before {
  content: '';
  position: absolute;
  border-top: 20px solid #8f0808;
  height: 0;
  width: 0;
  top: 100%;
}
.ribbon:after {
  border-left: 50px solid transparent;
  right: 0px;
}
.ribbon:before {
  border-right: 50px solid transparent;
  left: 0px;
}
.off {
  margin-top: -20px;
  font-size: 15px !important;
  font-weight: 700;
}

.img-container {
  padding-top: 75%;
  position: relative;
  background-color: #fff;
}

.img-container img {
  background-color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: auto !important;
  height: 80% !important;
  margin: auto !important;
}

a.disabled .img-container img:before {
  content: 'not available';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #00000082;
  color: #fff7f7;
  font-size: 1.2em;
  text-transform: uppercase;
  text-align: center;
  left: 10px;
  right: 10px;
}

.box {
  position: relative;
  flex-basis: calc(100% / 3);
  width: calc(100% / 3);
  flex-grow: 0;
  padding: 10px;
  min-width: 160px;
}
.discounted-price {
  font-size: 0.8rem;
  color: #9e9e9e;
  text-decoration: line-through;
  margin-right: 6px;
}
.new-price {
  font-size: 18px !important;
}

.onsale-cont {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}
.onsale-cont div.title.green-text {
  margin-top: 0 !important;
}
.p-card {
  background: #ffffff;
  box-shadow: 0px 10px 40px rgb(0 0 0 / 5%);
  border-radius: 5px;
  padding: 15px !important;
}
.pv-title {
  line-height: 18px;
}
@media screen and (max-width: 768px) {
  .box {
    flex-basis: calc(100% / 2);
    flex-grow: 0;
  }
}

@media screen and (max-width: 425px) {
  .box {
    flex-basis: 100%;
    flex-grow: 1;
  }
}
</style>
<template lang='pug'>
v-col(cols='12', sm='6', md='4')
  .pa-2.p-card
    a(v-if='!userlog')
      .img-container
        img(:src='photo', @error='onImgError', @click='dialog = true')
      p.title.light {{ product.variant.variantCode }}
      v-dialog(v-if='!userlog', v-model='dialog', persistent, max-width='530')
        v-card
          v-card-title.text-h5 Please register or login to view product details
          //- v-card-text Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running
          v-card-actions
            v-spacer
            v-btn(color='red darken-1', text, @click='dialog = false') Close
            v-btn(color='violet darken-1', text, @click='navtoregister()') Register Here
  .pa-2.p-card
    router-link(
      v-if='userlog',
      :to='{ name: "singledrink", params: { singleproduct: product, productCode: product.productCode, shopCode: product.shop.code, variantId: product.variant.id } }'
    )
      .img-container
        .ribbon(
          v-if='userlog && discountedPrice(product.variant.discounted, product.variant.price)'
        )
          span(v-if='product.variant.discounted.discountType === "percent"') {{ product.variant.discounted.amount }} %
          span(v-else)
            span.smalltxt PHP
            span.txt18px {{ product.variant.discounted.amount }}
          p.off OFF
        img(:src='photo', @error='onImgError')
      //- p.title.light.truncate {{ product.name }} ({{ product.variant.variantCode }})
      p.title.light.pv-title {{ product.variant.variantCode }}
      p.title.green-text.new-price(
        v-if='userlog && !discountedPrice(product.variant.discounted, product.variant.price)'
      ) {{ $utils.formatter.formatAmount(product.variant.price) }}
      .onsale-cont(
        v-if='userlog && discountedPrice(product.variant.discounted, product.variant.price)'
      )
        label.discounted-price {{ $utils.formatter.formatAmount(product.variant.price) }}
        .title.green-text.new-price {{ $utils.formatter.formatAmount(discountedPrice(product.variant.discounted, product.variant.price)) }}
      .vspace.large
    .row(v-if='userlog && isForReseller(userlog, product)')
      .col.pb-3
        .btn-compound.bordered.width100(
          :class='{ disabled: !canAddToCart(product.variant) }'
        )
          a.btn-compound-item.waves-effect(
            @click='quantity--',
            :class='quantity === 1 ? "disabled" : ""'
          )
            i.material-icons remove
          span.btn-compound-item.grow.center-align {{ quantity }}
          a.btn-compound-item.waves-effect(@click='quantity++')
            i.material-icons add

      .col.pb-3
        a.btn.width100.waves-effect(
          style='border-radius: 25px',
          @click='addToCart(product)',
          :class='{ disabled: !canAddToCart(product.variant) }'
        ) Add to Cart
</template>
<script>
import appalertmsg from '@/components/app-guest-alert-msg'

export default {
  name: 'appproductcard',
  data() {
    return {
      showModal: false,
      dialog: false,
      quantity: 1,
    }
  },
  meta: {
    title: 'Drinks',
  },
  props: ['product', 'index', 'path', 'userlogs'],
  computed: {
    photo() {
      return this.product.variant.photo
    },
    onImgError() {
      return './static/img/default-no_prev.png'
    },
    url() {
      return encodeURI(this.$route.path + '/' + this.path)
    },
    urldg() {
      return encodeURI(
        this.$route.path + '/' + this.product.variant.variantCode
      )
    },
    userlog() {
      return this.$store.state.auth.user
    },
  },
  mounted() {},
  methods: {
    isForReseller(user, product) {
      if (user.type === 'reseller') {
        if (product.tags === 'conventional') {
          return true
        } else {
          return false
        }
      } else if (user.type === 'customer') {
        if (product.tags === 'The Scotch Malt Whisky Society') {
          return true
        } else {
          return false
        }
      }
    },
    addToCart(selectedVariant) {
      let product = {
        ...selectedVariant.variant,
        parent: {
          id: selectedVariant.id,
          code: selectedVariant.productCode,
          name: selectedVariant.name,
        },
        shop: {
          id: selectedVariant.shop.id,
          code: selectedVariant.shop.code,
          name: selectedVariant.shop.name,
        },
        supplier: {
          id: selectedVariant.supplier.id,
          code: selectedVariant.supplier.code,
          name: selectedVariant.supplier.name,
        },
      }
      this.$store
        .dispatch('cart/addToCart', {
          product: product,
          quantity: this.quantity,
          // giftWrapped: this.giftWrapped,
          options: [
            {
              type: 'delivery:schedule',
              value: 'range:1;10',
            },
          ],
        })
        .then(() => {
          this.$emit('added')
        })
      this.$snackbar.success(
        selectedVariant.variant.variantCode + ' added to cart'
      )
    },
    canAddToCart(selectedVariant) {
      return selectedVariant.availableStock > 0
    },
    navtoregister() {
      this.$router.replace('/login')
    },
    openModal() {
      this.showModal = true
    },
    viewDrink(p) {
      this.$router.push({
        name: 'singledrink1',
        params: { singleproduct: this.product },
      })
    },
    discountedPrice(disData, ogPrice) {
      if (this.ifdiscountvalid(disData)) {
        if (disData.discountType === 'percent') {
          return ogPrice - (disData.amount / 100) * ogPrice
        } else if (disData.discountType === 'fix') {
          return ogPrice - disData.amount
        }
      }
    },
    ifdiscountvalid(disData) {
      if (disData) {
        let endDate = disData.end
        let CurrentDate = new Date()
        endDate = new Date(endDate)
        if (endDate > CurrentDate) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
  },
  components: {
    appalertmsg,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-product-card.vue